import { Configuration, PopupRequest } from "@azure/msal-browser";
import { environment } from "src/config/environment";

export const msalConfig: Configuration = {
	auth: {
		clientId: environment.REACT_APP_AZURE_CLIENT_ID || "",
		authority: `https://login.microsoftonline.com/${environment.REACT_APP_AZURE_TENANT_ID}`,
		redirectUri: window.location.origin + "/",
		postLogoutRedirectUri: window.location.origin + "/",
		navigateToLoginRequestUrl: true,
	},
	cache: {
		cacheLocation: "sessionStorage", // Use sessionStorage for better security
		storeAuthStateInCookie: false,
	},
};

// Scopes for API access
export const apiTokenRequest: PopupRequest = {
	scopes: [environment.REACT_APP_AZURE_API_SCOPE || "api://your-api-id/.default"],
};

// Scopes for login
export const loginRequest: PopupRequest = {
	scopes: ["openid", "profile", "email"],
};
